/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IEscrowInvitationCreateMutationVariables = Types.Exact<{
  escrowId: Types.Scalars['ID']['input'];
  escrowInvitationParams: Types.IEscrowInvitationCreateParams;
}>;

export type IEscrowInvitationCreateMutation = {
  __typename?: 'Mutation';
  escrowInvitationCreate?: {
    __typename?: 'EscrowInvitationCreatePayload';
    success: boolean;
    errors?: Array<string> | null;
    escrowInvitation?: {
      __typename?: 'EscrowInvitation';
      id: string;
      status: Types.InvitationStatusEnum;
      companyName: string;
      partyType: string;
      userName?: string | null;
      userEmail?: string | null;
      escrow:
        | { __typename?: 'ContinuityEscrow'; id: string; beneficiaryConfigured: boolean; depositorConfigured: boolean }
        | { __typename?: 'SaasEscrow'; id: string; beneficiaryConfigured: boolean; depositorConfigured: boolean }
        | { __typename?: 'SoftwareEscrow'; id: string; beneficiaryConfigured: boolean; depositorConfigured: boolean };
      user?: { __typename?: 'User'; id: string; name?: string | null; email: string; phone?: string | null } | null;
      policy: { __typename?: 'EscrowInvitationPolicy'; accept: boolean; reject: boolean; update: boolean };
    } | null;
  } | null;
};

export const EscrowInvitationCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'escrowInvitationCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'escrowId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'escrowInvitationParams' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'EscrowInvitationCreateParams' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'escrowInvitationCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'escrowId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'escrowId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'escrowInvitationParams' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'escrowInvitationParams' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'escrowInvitation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EscrowInvitationFields' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'escrow' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'beneficiaryConfigured' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'depositorConfigured' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EscrowInvitationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EscrowInvitation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partyType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'policy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'accept' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'update' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'userName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userEmail' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'escrow' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IEscrowInvitationCreateMutation, IEscrowInvitationCreateMutationVariables>;
